import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { withStyles } from '@material-ui/core/styles'

import MembershipBenefits from '../MembershipBenefits'
import { formatTermDate, planDisplay } from './addOnRenewalHelpers'

// The same look as MembershipUpgrades in the primary's renewal popup.
const styles = (theme) => ({
    label: {
        fontWeight: 500,
        fontSize: theme.spacing(2.5)
    },
    accordionDetails: {
        display: 'flex',
        flexDirection: 'column'
    },
    term: {
        marginBottom: theme.spacing(2)
    }
})

/**
 * Step 1: the add-on plan, its price and the term, which follows the
 * primary's dates. An open-ended term (no end date) reads "from <start>, ongoing".
 */
const PlanDetails = ({ classes, plan, termStart, termEnd, onContinue, continueLabel = 'Continue' }) => {
    const display = planDisplay(plan)
    const start = formatTermDate(termStart)
    const end = formatTermDate(termEnd)

    return <Grid container direction="column" spacing={2}>
        <Grid item>
            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-label="Expand" aria-controls="addon-plan-content" id="addon-plan-header">
                    <Typography className={classes.label}>{display.name} - {display.priceLine}</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.accordionDetails}>
                    {(start || end) && <Typography className={classes.term} data-testid="addon-term">
                        {end ? `Term: ${start || 'today'} to ${end}` : `Term: from ${start || 'today'}, ongoing, billed monthly`}
                    </Typography>}
                    <MembershipBenefits benefits={display.benefits} />
                </AccordionDetails>
            </Accordion>
        </Grid>
        <Grid item>
            <Button fullWidth variant="contained" size="large" color="primary" onClick={onContinue}>{continueLabel}</Button>
        </Grid>
    </Grid>
}

export default withStyles(styles)(PlanDetails)
